export function slugify(name: string) {
	return name.toLowerCase()
		.replaceAll(/[^a-zA-Z0-9-]+/g, "-")
		.replaceAll(/-+/g, "-");
}
